import React from 'react';

const TranslationsContext = React.createContext({
    translations: null
});

export default TranslationsContext;
